import { Link } from 'react-router-dom';
import { useAuthContext } from '../adminlogin/useAuthContext';
import { useAdminLogout} from '../adminlogin/useAdminLogout';

const Header = () => {

    const {logout} = useAdminLogout();

    const handleClick = () =>{
        logout();
    }

    const {adminuser} = useAuthContext();

     return (
        <>
       <nav  className="navbar navbar-dark navbar-expand-md " >
            <div className="container-fluid">
                <Link className="navbar-brand" to="/admin">Admin Home</Link>
                <button 
                className="navbar-toggler" 
                type="button" 
                data-bs-toggle="collapse" 
                data-bs-target="#navbarNav" 
                aria-controls="navbarNav" 
                aria-expanded="false" 
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav  ml-auto">
                    <li className="nav-item">
                         <Link className="nav-link" aria-current="page" to="/admin">Home</Link>
                    </li>
                    {
                        adminuser && (
                            <>
                                <li>
                                   <Link className="nav-link" aria-current="page" to="/admin/student-applications">Student Applications</Link>
                                </li>
                                <li><Link to="/admin/religion" className="nav-link" aria-current="page" >Manage Religion</Link></li>
                                <li><Link to="/admin/religion/create" className="nav-link" aria-current="page"  >Add Religion</Link></li>
                                <li>
                                     <Link className="nav-link" aria-current="page" onClick={handleClick}>Logout</Link>
                                </li>
                            </>
                          
                        )
                        
                    }

                </ul>
                </div>
            </div>
        </nav>
        </>
     );
}

export default Header;